import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installImpersonationFetch } from './utils/impersonationFetch';

// Inyecta automáticamente X-Impersonation-Token en cada fetch al backend
// cuando hay una sesión de impersonation activa. Idempotente.
installImpersonationFetch();

// --- Oculta el warning de ResizeObserver en todas las etapas ---
// Este error es benigno y ocurre frecuentemente con React Flow y MUI
if (typeof window !== "undefined") {
  const resizeObserverErr = /ResizeObserver loop/;

  // Silencia el mensaje en la consola
  const realConsoleError = window.console.error;
  window.console.error = (...args) => {
    if (args[0] && typeof args[0] === "string" && resizeObserverErr.test(args[0])) {
      return;
    }
    realConsoleError(...args);
  };

  // Silencia el evento global de error (captura antes que React overlay)
  window.addEventListener("error", (e) => {
    if (e.message && resizeObserverErr.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // useCapture = true para capturar antes que otros handlers

  // Silencia el evento de promesas no manejadas
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.message && resizeObserverErr.test(e.reason.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  // Parche adicional para el ResizeObserver nativo
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Envuelve el callback en requestAnimationFrame para evitar el error
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            if (!resizeObserverErr.test(e.message)) {
              throw e;
            }
          }
        });
      });
    }
  };
}

// --- Render principal ---
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- Métricas opcionales ---
reportWebVitals();

